<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19PcHnL/tc-custom/9781504071727.jpg?1728353338802" alt="This image is the cover for the book Escape to Perdition, The Prague Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Escape to Perdition, The Prague Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <b>A secret agent in Prague faces love, death, and a crisis of conscience in this gripping international thriller.</b><br/><br/>Herbert Biely, aged hero of the Prague Spring, stands poised to reunite the Czech and Slovak Republics years after the Velvet Revolution. But other parties have their own agendas and plans for the fate of the region. A shadowy collective exists that will do anything to preserve the status quo. <br/><br/>Peter Lowe’s mission is to prevent reunification by any means possible. But Peter is not all that he seems. A troubled man desperate to escape the past, he’s beginning to question the cause, his assignment, his superiors, and himself. And when he falls in love with his intended target, the danger escalates. As alliances shift and the body count rises, Prague becomes the focal point for intrigue on an international scale.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Silvester
      </h2>
      
      <p class="authorDescription body article">James's books combine his love of Cold War spy fiction with his passion for the Czech Republic and Slovakia. A former Mod DJ, James has been recognised as a voice of 'Brex-Lit' and is a staunch member of the 48%. Away from thrillers, he is a contributing editor of unofficial Doctor Who charity anthologies.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ad49578